<div class="conversation-drop">
    <div class="heading">
        <span id="buzz" (click)="toggleAchievement()" class="title active"><a style="color: #3d4758;" href="javascript:void(0);">{{bs.getResource('rbkey_BzzlnLBL')}}</a></span>
        <span id="achieve" (click)="toggleAchievement()" class="title"><a style="color: #3d4758;" href="javascript:void(0);">{{bs.getResource('rbkey_AchvmntsLbL')}}</a></span>
        <div class="pull-right" style="display:block;">
            <div class="btn-group mb-sm">
                <a href="javascript:void(0);" (click)="openPanelSetting()" class="dropdown-toggle text-link">
                    <i class="fa fa-2x fa-cog"></i>
                </a>
            </div>
        </div>
    </div>
    <app-loader *ngIf="loader"></app-loader>
    <div class="conversation-drop-inner" *ngIf="!loader && !showAchievement">
        <div class="input-image">
            <input type="text" (click)="openSharingPanel(TimeLineInline)" class="form-control" placeholder="{{bs.getResource('rbkey_WhtsOnYrMindLBL')}}">
            <div class="position-right">
                <a href="javascript:void(0);" style="display: inline;" (click)="openSharingPanel(TimeLineInline)">                  
                    <img src="assets/img/image-icon.png" alt="Icon">
                </a>
                <a href="javascript:void(0);" style="display: inline;" (click)="openSharingPanel(TimeLineInline)">                   
                    <img src="assets/img/attach-icon.png" alt="Icon">
                </a>               
            </div>
        </div>
        <div class="conversation-box"  *ngIf="NoTimeLine"  style="border: none;">{{bs.getResource('rbkey_NoPstAvlblMSG')}}</div>
        <div class="conversation-box" *ngFor="let item of TimeLineLists;let i = index">
            <div  *ngIf="bs.getUserAttr('UserId') != item['Originator']" class="c-box-row-1" style="background: #BFC2C7; padding: 2px 0px 2px 10px;" >
                <div class="cb-left-section">
                    <div class="left-img" style="width: 30px;height:30px;">
                        <img src="{{item['SharedByUserThumbnail']}}" alt="img">
                    </div>
                    <div class="name-details">
                        <div class="name">{{bs.getResource('rbkey_ShrdByLBL')}} ( {{item['SharedByUserName']}} ) </div>
                    </div>
                </div>
                <div class="cb-right" style="margin: 5px 10px 0px 0px;">
                    <div class="days-text">{{item['SharedDuration']}}</div>
                    <div class="cb-right-menu"><a href="javascript:void(0);" data-toggle="dropdown" class="dropdown-toggle cb-menu"></a>
                        <ul role="menu" class="dropdown-menu animated fadeIn right">                            
                            <li *ngIf="item['AllowDelete']"><a href="#"  (click)="DeleteTimeLine(item['TileId'])">{{bs.getResource('rbkey_CnvrstnCmmntDltBTN')}}</a></li>
                            <li *ngIf="!item['IsEditable']"><a href="#" (click)="ReportAbuseTimeLine(item,i)">{{bs.getResource('rbkey_RprtAbsCmmntLBL')}}</a></li>
                            <li><a href="javascript:void(0);" (click)="openSharingPanel(item)">{{bs.getResource('rbkey_ShrLBL')}}</a></li>
                            <li *ngIf="item['SharedBy'] != bs.getUserAttr('UserId')"><a href="javascript:void(0);"  (click)="RemoveTile(item)">{{bs.getResource('rbkey_HdThisPstLBL')}}</a></li>
                            <li *ngIf="item['SharedBy'] != bs.getUserAttr('UserId')"><a href="javascript:void(0);" (click)="BlockUserTimeLineTiles(item)" [innerHTML]="item['BlockTileUserText']"></a></li>
                        </ul>
                    </div>
                </div>              
            </div>
            <div class="c-box-row-1">
                <div class="cb-left-section">
                    <div class="left-img">
                        <img src="{{item['OriginatorThumbnail']}}" alt="img">
                    </div>
                    <div class="name-details">
                        <div class="name">{{item['OriginatorName']}} </div>
                        <div class="post" *ngIf="item['OriginatorRole']!=''">{{item['OriginatorRole']}}</div>
                    </div>
                </div>
                <div class="cb-right">
                    <div class="days-text">{{item['PostedDate']}}</div>
                    <div class="cb-right-menu" *ngIf="bs.getUserAttr('UserId') == item['Originator']"><a href="javascript:void(0);" data-toggle="dropdown" class="dropdown-toggle cb-menu"></a>
                        <ul role="menu" class="dropdown-menu animated fadeIn right">
                            <li *ngIf="item['AllowDelete']"><a href="#"  (click)="DeleteTimeLine(item['TileId'])">{{bs.getResource('rbkey_CnvrstnCmmntDltBTN')}}</a></li>
                            <li><a href="javascript:void(0);" (click)="openSharingPanel(item)">{{bs.getResource('rbkey_ShrLBL')}}</a></li>                          
                        </ul>
                    </div>
                </div>
            </div>
            <div class="c-box-row-2">
                <span class="c-box-2-heading-views" style="display:none;">988 Views</span>               
                <div class="c-box-in-descrip" [innerHTML]="item['Tittle'] | safeHtml">
                    <a href="javascript:void(0);" class="see-more-link" style="display:none;">...see more</a>
                </div>
                <div class="world-round-sec">
                    <img src="{{item['InlineImage']}}" alt="Image" class="wr-image">
                    <a *ngIf="item['AttachementName']!=''" href="javascript:void(0);" (click)="OpenAttachment(item['Attachement'])" class="wrs-link"><i class="fa-paperclip fa"></i>{{item['AttachementName']}}</a>
                </div>
                <div class="c-box-bottom">
                    <div class="c-box-left-icons">
                        <div class="likes-div">
                            <a href="javascript:void(0);" class="likes likes-on-tool" (click)="LikeTimeLineTile(item,i)" title="{{bs.getResource('rbkey_LksLBL')}}" [ngClass]="{'no-cursor':  item['SharedBy'] == bs.getUserAttr('UserId') }">
                                <i class="fa fa-thumbs-up" id="TimeLine{{i}}" [ngClass]="{'fa-thumbs-up-blue':  item['IsLiked']==true }"></i>
                                <span class="reviews" id="TimeLineLike{{i}}">{{item['LikeCount']}}</span></a>
                        </div>
                        <a href="javascript:void(0);" class="comments" title="{{bs.getResource('rbkey_CmmntsLBL')}}">
                            <i class="fa fa-comment"></i>
                            <span class="reviews" id="Review{{item['TileId']}}">{{item['CommentCount']}}</span>
                        </a>
                        <div class="share-div rtl-share-div">
                            <a href="javascript:void(0);" (click)="openSharingPanel(item)" class="shares shares-tool" title="{{bs.getResource('rbkey_ShrdLBL')}}">
                                <i class="fa fa-share"></i>
                                <span class="reviews">{{item['SharedCount']}}</span>
                            </a>
                        </div>

                        <a href="javascript:void(0)" class="comments" title="{{bs.getResource('rbkey_RprtAbsCmmntLBL')}}" *ngIf="item['SharedBy'] != bs.getUserAttr('UserId')">
                            <i id="TimeLineReportAbuse{{item['TileId']}}" [ngClass]="{'fa-flag-red':  item['IsReportedAbuse']==true }"
                                class=" fa fa-flag"></i></a>
                    </div>
                </div>
            </div>
            <timeline-conversation [UserThumbnail]="item['UserSelfThumbnail']" [TileId]="item['TileId']" [Comments]="item['TimeLineConversationList']" (count)="onCount($event)"></timeline-conversation>
        </div>
        <div class="conversation-box" *ngIf="loadMoreButton">
            <div class="c-box-row-2-1">
                <div class="world-round-sec" (click)="loadMoreData();" style="text-align: center;">
                    <a href="javascript:void(0);" style="padding: 8px; color: #3d4758; font-size: 2.0em;">
                        <i id="loadMoreIcon" [appLoadingIcon]="loadingMoreData" class="fa fa-angle-double-down"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="conversation-drop-inner" *ngIf="showAchievement">
 
        <div class="conversation-box"  *ngIf="NoAcheivement"  style="border: none;">{{bs.getResource('rbkey_NoAchvmntsAvlblMSG')}}</div>
        <div class="conversation-box" *ngFor="let item of AchievmentLists;let i = index">
            <div class="c-box-row-1">
                <div class="cb-left-section">
                    <div class="left-img">
                        <img src="{{item['OriginatorThumbnail']}}" alt="img">
                    </div>
                    <div class="name-details">
                        <div class="name">{{item['OriginatorName']}} </div>
                        <div class="post" *ngIf="item['UserJobRole']!=''">{{item['OriginatorRole']}}</div>
                    </div>
                </div>
                <div class="cb-right">
                    <div class="days-text">{{item['PostedDuration']}}</div>
                    <div class="cb-right-menu"><a href="javascript:void(0);" data-toggle="dropdown" class="dropdown-toggle cb-menu"></a>
                        <ul role="menu" class="dropdown-menu animated fadeIn right">                          
                            <li><a href="javascript:void(0);" (click)="openSharingPanel(item)">{{bs.getResource('rbkey_ShrLBL')}}</a></li>
                           
                        </ul> 
                    </div>
                </div>
            </div>
            <div class="c-box-row-2">
           
                <div class="c-box-in-descrip" [innerHTML]="item['Tittle'] | safeHtml">                 
                </div>
                <div class="world-round-sec">
                    <img src="{{item['InlineImage']}}" alt="Image" class="wr-image">
                    <a *ngIf="item['AttachementName']!=''" href="javascript:void(0);" (click)="OpenAttachment(item['Attachement'])" class="wrs-link"><i class="fa-paperclip fa"></i>{{item['AttachementName']}}</a>
                </div>
            </div>
           
        </div>
    </div>
    <div class="center-overlay box-overlay">
        <div class="inn-text">
            Drag and<br>
            Drop
        </div>
    </div>
</div>